
export default class Response{
    constructor(_valid, _message, _code){
        this._response = { valid: _valid, message: _message, code: _code }
    }

    init(){
        return this._response
    }
}